<fb-section-card [title]="'CUSTOMER_EMAILS' | translate" [description]="'CUSTOMER_EMAILS_DESC' | translate">
    @if (!editorAvailable()) {
        <div class="flex items-start gap-3 p-3 mb-4 rounded-md bg-concern-warn border border-concern-warn-border">
            <i class="ph ph-info text-concern-warn-dot"></i>
            <p class="text-sm text-concern-warn-title">{{ 'CUSTOM_EMAILS_NEED_MAILLUNE' | translate }}</p>
        </div>
    }

    <div class="flex flex-col divide-y divide-border">
        @if (loading()) {
            @for (i of [1, 2, 3]; track i) {
                <div class="py-4"><p-skeleton height="3.5rem" borderRadius="8px" /></div>
            }
        }
        @for (section of loading() ? [] : groups(); track section.group) {
            <p class="pt-5 pb-1 first:pt-0 text-xs font-semibold uppercase tracking-widest text-text-muted border-0!">
                {{ 'CUSTOM_EMAIL_GROUP_' + section.group | translate }}
            </p>
        @for (email of section.emails; track email.kind) {
            @let custom = email.mode === 'CUSTOM';
            @let busy = busyKind() === email.kind;
            <div class="flex flex-wrap items-center gap-4 py-3 first:pt-0 last:pb-0">
                <!-- Preview -->
                <div
                    class="w-[44px] h-[56px] shrink-0 rounded-sm border border-border overflow-hidden flex items-center justify-center"
                    [class]="custom ? 'bg-surface' : 'bg-surface-2'">
                    @if (custom && thumbnail(email); as src) {
                        <img [src]="src" alt="" class="w-full h-full object-cover object-top" />
                    } @else {
                        <i [class]="'ph text-xl ' + icon(email.kind)" [class.text-brand]="custom" [class.text-text-muted]="!custom"></i>
                    }
                </div>

                <!-- Name, description, subject -->
                <div class="flex flex-col gap-1 flex-1 min-w-60">
                    <span class="font-semibold text-text flex items-center gap-2">
                        {{ 'CUSTOM_EMAIL_' + email.kind | translate }}
                        @if (!email.available) {
                            <span class="text-[11px] font-medium px-1.5 py-0.5 rounded-sm bg-surface-2 text-text-muted">{{ 'CUSTOM_EMAIL_OFF_FOR_VENUE' | translate }}</span>
                        }
                    </span>
                    <span class="text-xs text-text-muted">{{ 'CUSTOM_EMAIL_' + email.kind + '_DESC' | translate }}</span>
                    @if (custom) {
                        @if (editingSubject() === email.kind) {
                            <div class="flex items-center gap-2 mt-1">
                                <input
                                    pInputText
                                    pSize="small"
                                    class="flex-1"
                                    [ngModel]="subjectDraft()"
                                    (ngModelChange)="subjectDraft.set($event)"
                                    (keydown.enter)="saveSubject(email)"
                                    (keydown.escape)="editingSubject.set(null)"
                                    [attr.aria-label]="'EMAIL_SUBJECT' | translate" />
                                <button pButton type="button" size="small" [text]="true" (click)="saveSubject(email)">
                                    <i class="ph ph-check"></i>
                                </button>
                            </div>
                        } @else {
                            <button
                                type="button"
                                class="mt-1 inline-flex items-center gap-1.5 text-sm text-text-2 hover:text-text w-fit text-left"
                                (click)="startSubjectEdit(email)">
                                <span class="text-text-muted">{{ 'EMAIL_SUBJECT' | translate }}:</span>
                                @if (subject(email); as text) {
                                    <span class="truncate max-w-md">{{ text }}</span>
                                } @else {
                                    <span class="italic text-concern-warn-title">{{ 'CUSTOM_EMAIL_ADD_SUBJECT' | translate }}</span>
                                }
                                <i class="ph ph-pencil-simple text-text-muted"></i>
                            </button>
                        }
                    }
                </div>

                <!-- Actions -->
                <div class="flex items-center gap-2">
                    @if (custom) {
                        <button pButton type="button" size="small" [outlined]="true" [disabled]="busy || !editorAvailable()" (click)="editTemplate.emit(email)">
                            <i class="ph ph-paint-brush"></i>
                            <span>{{ 'EDIT_TEMPLATE' | translate }}</span>
                        </button>
                    }
                    <div class="inline-flex p-0.5 rounded-md bg-surface-2 border border-border" role="radiogroup">
                        @for (option of modeOptions; track option.value) {
                            @let active = email.mode === option.value;
                            <button
                                type="button"
                                role="radio"
                                [attr.aria-checked]="active"
                                class="px-3 py-1.5 text-sm rounded-sm transition-colors inline-flex items-center gap-1.5"
                                [class]="active ? 'bg-surface text-text font-medium shadow-xs' : 'text-text-muted hover:text-text'"
                                [disabled]="busy || (option.value === 'CUSTOM' && !editorAvailable())"
                                (click)="modeChanged(email, $any(option.value))">
                                @if (busy && !active) {
                                    <i class="ph ph-circle-notch animate-spin"></i>
                                }
                                {{ option.label | translate }}
                            </button>
                        }
                    </div>
                </div>
            </div>
        }
        }
    </div>

    <p class="mt-4 text-xs text-text-muted flex items-center gap-1.5">
        <i class="ph ph-shield-check"></i>
        {{ 'CUSTOM_EMAILS_FALLBACK_NOTE' | translate }}
    </p>
</fb-section-card>
